/**
 * When user leaves a path segment that matches pathSegment, invalidate these query keys.
 * Ensures custom field definition changes (e.g. from admin) are reflected in the React frontend.
 */
export const iframeCacheInvalidationRules: { pathSegment: string; queryKeys: string[] }[] = [
  {
    pathSegment: '/admin',
    queryKeys: ['styles-data', 'items-data', 'styles-custom-fields-meta', 'items-meta'],
  },
];

/**
 * Iframe paths that are replaced by React views when the given feature flag is enabled.
 */
export const iframePathFeatureFlagOverrides: { path: string; featureFlag: string }[] = [
  { path: '/item', featureFlag: 'ItemsTableView' },
  { path: '/style', featureFlag: 'StylesTableView' },
  { path: '/compliance', featureFlag: 'ComplianceDocGenerator' },
];
